var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalysisChart',{attrs:{"endpoint":"web/get-cumulative-feed-analysis","data-key":"total_feed","standard-key":"standard_feed","series-label":"Cumulative Feed","standard-label":"Standard Cumulative Feed","yaxis-title":"Feed"}})}
var staticRenderFns = []

export { render, staticRenderFns }